import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export const KeyBenefits = () => {
  const benefits = [
    'True field-to-office integration',
    'Real-time decision-making',
    'Minimizes delays and cost overruns',
    'Eliminates manual entry and duplicated work',
    'Standardizes reporting across projects and contractors',
  ];

  return (
    <section id="benefits" className="py-24 bg-[#0D1115] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-['Montserrat'] font-bold text-4xl sm:text-5xl text-[#F5F7F8] mb-6">
              KEY <span className="text-[#30D5C8]">BENEFITS</span>
            </h2>
            <p className="text-[#CBD3D9] text-lg sm:text-xl font-['Open_Sans']">
              Transform your industrial projects with measurable improvements
            </p>
          </div>

          <div className="space-y-4">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-[#1A2733]/50 backdrop-blur-sm border border-[#506273]/30 rounded-lg p-6 hover:border-[#30D5C8]/50 transition-all duration-300 card-hover group"
              >
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-[#30D5C8]/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-[#30D5C8]/20 transition-colors">
                    <CheckCircle2 className="text-[#30D5C8]" size={24} />
                  </div>
                  <p className="text-[#F5F7F8] text-lg sm:text-xl font-['Open_Sans'] font-semibold">
                    {benefit}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};